module.exports = __webpack_public_path__ + "img/rmcs_1.777a2d10.jpg";